import React from 'react';

function Searchbar(props) {
  const { onChange, onSearch, value } = props;

  return (
    <div className="card" style={{ position: 'relative', zIndex: 3 }}>
      <div style={{ padding: '15px 25px 0 15px', }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <div className="form-icon position-relative" style={{ width: '100%' }}>
              <svg className="fea icon-sm icons" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 10.8a2 2 0 1 0-2-2a2 2 0 0 0 2 2Zm-.71 6.91a1 1 0 0 0 1.42 0l4.09-4.1a6.79 6.79 0 1 0-9.6 0ZM7.23 8.34a4.81 4.81 0 0 1 2.13-3.55a4.81 4.81 0 0 1 5.28 0a4.82 4.82 0 0 1 .75 7.41L12 15.59L8.61 12.2a4.77 4.77 0 0 1-1.38-3.86ZM19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"/></svg>
              <input
                type="text"
                className="form-control ps-5 mb-3"
                placeholder="Wpisz miejscowość lub nazwę rzeki"
                required=""
                value={value}
                onChange={e => onChange(e.target.value)}
                onKeyUp={e => e.code === 'Enter' && onSearch()}
              />
          </div>
          <div>
            <button className="btn btn-primary" onClick={onSearch}>Szukaj</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Searchbar;